import React, {useContext} from 'react'
import {Switch, message} from "antd"
import {
    EditOutlined
} from '@ant-design/icons'
import {changeStatus} from "../../../../services/api/apiSettingShippingRule"
import SettingShippingRuleContext from "../../context/SettingShippingRuleContext"
import {Link} from "react-router-dom"
import { canViewStoreName } from '../../../../services/StorageServices'

const TableRow = (props) => {
    const canViewStore = canViewStoreName()
    const {reLoadShippingRules} = useContext(SettingShippingRuleContext)
    const {shippingRule, platforms} = props
    const {allow: platformAllow, disallow: platformDisallow} = shippingRule.platform
    const {allow: countryAllow, disallow: countryDisallow} = shippingRule.country
    const {allow: stateAllow, disallow: stateDisallow} = shippingRule.state
    const {allow: storeAllow, disallow: storeDisallow} = shippingRule.store
    const {allow: typeAllow, disallow: typeDisallow} = shippingRule.type
    const {allow: tagAllow, disallow: tagDisallow} = shippingRule.tag

    let arrA = []
    let arrD = []
    if (!!platformDisallow && platformAllow.length > 0) {
        for (let i = 0; i < platformAllow.length; i++) {
            const findP = platforms.find(item => item.value === platformAllow[i])
            if (findP !== undefined) arrA.push(findP)
        }
    }
    if (!!platformDisallow && platformDisallow.length > 0) {
        for (let i = 0; i < platformDisallow.length; i++) {
            const findD = platforms.find(item => item.value === platformDisallow[i])
            if (findD !== undefined) arrD.push(findD)
        }
    }


    const _changeStatusShippingRule = async () => {
        const {shippingRule} = props

        try {
            const payload = {
                active: shippingRule.hasOwnProperty('deleted_at')
            }

            const {success, message: messChange} = await changeStatus(shippingRule._id, payload)

            if (!success) {
                return message.error(messChange);
            }

            reLoadShippingRules()
            message.success('Update status success!');
        } catch (e) {

        }
    }

    const { carrier, detect_by_variants } = { ...shippingRule }
    const rowWarning = !!carrier && !carrier.is_active ? 'rowWarning' : ''

    return (
        <tr className={`TableRow ${rowWarning}`}>
            <td>{shippingRule.priority}</td>
            <td>{arrA.length > 0 ? arrA.map(itemA => itemA.name).join(', ') : 'All'}<span
                className="disallow d-block">{arrD.length > 0 && arrD.map(itemD => itemD.name).join(', ')}</span></td>
            <td>{countryAllow.length > 0 ? countryAllow.join(', ') : 'All'}<span
                className="disallow d-block">{countryDisallow.join(', ')}</span></td>
            <td>{stateAllow.length > 0 ? stateAllow.join(', ') : 'All'}<span
                className="disallow d-block">{stateDisallow.join(', ')}</span></td>
            {canViewStore && <td>{storeAllow.length > 0 ? storeAllow.join(', ') : 'All'}<span
                className="disallow d-block">{storeDisallow.join(', ')}</span></td>}
            <td>
                {detect_by_variants && <span className='d-block' style={{color: 'red'}}>(Detect by variant)</span>}
                
                {typeAllow.length > 0 ? typeAllow.join(', ') : 'All'}
                <span className="disallow d-block">{typeDisallow.join(', ')}</span>
            </td>
            <td>{tagAllow.length > 0 ? tagAllow.join(', ') : 'All'}<span
                className="disallow d-block">{tagDisallow.join(', ')}</span></td>
            <td>{shippingRule.hasOwnProperty('weight')
                ? <span>
                    {shippingRule.weight.gte > 0 && <span>{`>=`} {shippingRule.weight.gte}</span>}
                    {shippingRule.weight.lte > 0 &&
                    <span className="disallow d-block">{`<=`} {shippingRule.weight.lte}</span>}
                </span>
                : 'All'}
            </td>
            <td>{shippingRule.shipping_carrier}</td>
            <td>{shippingRule.original_carrier}</td>
            <td><Switch onChange={_changeStatusShippingRule}
                        defaultChecked={!shippingRule.hasOwnProperty('deleted_at')}/></td>
            <td className="text-center">
                <span className="text-primary">
                    <Link className="linkDetail" to={`/shipping-rule/${shippingRule._id}`}><EditOutlined/></Link>
                </span>
            </td>
        </tr>
    )
}

export default TableRow
